module.exports = __webpack_public_path__ + "static/media/carta_30.7dbf8c3c.jpg";